<template>
  <div class="d-flex justify-center align-center flex-column">
    <div class="d-flex flex-column text-center mb-10" style="max-width: 350px; width: 100%">
      <v-text-field
        outlined
        hide-details
        label="Seu nome"
        v-model="form.name"
        :append-icon="form.name !== user.name ? '' : 'mdi-pencil'"
        :append-outer-icon="form.name !== user.name ? 'mdi-content-save' : ''"
        @click:append-outer="updateName()"
      ></v-text-field>
      <v-text-field
        class="mt-4"
        outlined
        label="Seu email"
        v-model="form.email"
        hide-details
        readonly
      >
        <template v-slot:append>
          <v-tooltip top v-if="user.google">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" color="red lighten-1">mdi-google</v-icon>
            </template>
            <span>Você está conectado com o Google</span>
          </v-tooltip>
          <v-tooltip top v-if="user.facebook">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" color="blue darken-1">mdi-facebook</v-icon>
            </template>
            <span>Você está conectado com o Facebook</span>
          </v-tooltip>
        </template>
      </v-text-field>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      loading: false,
      form: {}
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },
  watch: {
    user: {
      immediate: true,
      handler: function (user) {
        if (user) {
          this.form = JSON.parse(JSON.stringify(user))
        }
      }
    }
  },
  methods: {
    async updateName () {
      if (!this.form.name) {
        return false
      }

      this.loading = true

      await this.$store.dispatch('auth/update', { name: this.form.name })

      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
</style>